import React from 'react';

interface ScreenCardProps {
  children: React.ReactNode;
  surface?: 'panel' | 'soft' | 'soft-alt' | 'none';
  className?: string;
  style?: React.CSSProperties;
  'data-testid'?: string;
}

export const SOFT_ALT_BACKGROUND = 'color-mix(in srgb, var(--color-bg-alt) 80%, transparent)';

// Standard frame for soft-alt cards; shared so the geometry stays in sync across screens.
export const SOFT_ALT_CARD_FRAME = 'rounded-2xl px-5 py-7 shadow-none';

export function ScreenCard({ children, surface = 'panel', className = '', style, 'data-testid': dataTestId }: ScreenCardProps) {
  const surfaceClassName = surface === 'panel'
    ? 'screen-card screen-card--panel panel rounded-2xl shadow-xl'
    : surface === 'soft' || surface === 'soft-alt'
      ? 'screen-card screen-card--soft panel-soft rounded-xl'
      : 'screen-card screen-card--bare';
  const resolvedStyle = surface === 'soft-alt'
    ? { backgroundColor: SOFT_ALT_BACKGROUND, ...style }
    : style;

  return (
    <section className={`${surfaceClassName} ${className}`.trim()} style={resolvedStyle} data-testid={dataTestId}>
      {children}
    </section>
  );
}
